export default {
  data: () => ({
    translations: {
      generalLimits: {
        el: 'Γενικά όρια',
        en: 'General Limits',
        it: 'Limiti generali',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },
      onlineTransactions: {
        el: 'Όρια online συναλλαγών',
        en: 'Online Transaction Limits',
        it: 'Limiti delle transazioni online',
      },
      offlineTransactions: {
        el: 'Όρια offline συναλλαγών',
        en: 'Offline Transaction Limits',
        it: 'Limiti delle transazioni offline',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      modalTitle1: {
        el: 'Αλλαγή ορίων συναλλαγών για όλα τα καταστήματα',
        en: 'Change transaction limits for all stores',
        it: 'Modifica i limiti di transazione per tutti i negozi',
      },
      modalTitle2: {
        el: 'Αλλάξτε τα όρια συναλλαγών για το κατάστημα ',
        en: 'Change transaction limits for store ',
        it: 'Cambiare i limiti delle transazioni per el negozio ',
      },
      dailyTransactionLimits: {
        el: 'Ημερήσια όρια συναλλαγών',
        en: 'Daily Transaction Limits',
        it: 'Limiti di transazioni giornaliere',
      },
      amount: {
        el: 'Ποσό',
        en: 'Amount',
        it: 'Importo',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
    },
  }),
};
